import React, { useEffect, useRef, useState } from "react";
import "../MainPage.css";
import unlockSVG from "../../../assets/svg/unlock_svg.svg";
import MembershipDealsModal from "../../../components/Modals/MembershipDealsModal/MembershipDealsModal";
import { useDispatch, useSelector } from "react-redux";
import { currency } from "../../../utils/currency";
import { isValidTimeZone } from "../../../utils/utils";
import dayjs from "dayjs";
import { fetchPromotionsApi } from "../../../Services/mainPageService";
import { fetchPromotions } from "../../../redux/actions/hotelInfoAction";

const SecretMemberDeal = ({
  price,
  isRatePlan,
  selectRoomBtn,
  getMembershipDetails,
  getSecretMemberDealUrl,
  applyPromotion,
  promotionRes
}) => {
  const [showMembershipModal, setShowMembershipModal] = useState({
    isOpen: false,
  });
  const isUnlocked = sessionStorage.getItem("isMembershipUnlocked") === "true";
  // const [isEnabled, setIsEnabled] = useState(false);
  const isEnabledRef = useRef(false);

  const [membershipDetails, setMembershipDetails] = useState({
    name: "Member-Only Rate",
    description: "Unlock and reveal the best price for your stay.",
  });

  const { hotelData, dateRange } = useSelector((state) => state.hotelInfo);

  const [response, setResponse] = useState({});

  useEffect(() => {
    if (promotionRes?.status === 200) {
      setResponse(promotionRes);
    }
  }, [promotionRes]);

  const dispatch = useDispatch();

  const { id } = hotelData;

  const enableSecretMemberDeal = async () => {
    const url = getSecretMemberDealUrl();
    if (response?.status === 200) {
      setMembershipDetails({
        name: response?.data?.[0]?.name || "Member-Only Rate",
        description:
          response?.data?.[0]?.description ||
          "Unlock and reveal the best price for your stay.",
      });
      // const isBeacon = hotelData?.chainName === "beacon" || hotelData?.chainName === "zinc" ||  hotelData?.id !== 2825;
      const isBeacon =
        hotelData?.id === 2825 ||
        hotelData?.chainName === "beacon" ||
        hotelData?.chainName === "zinc";
      if (response?.data?.length) {
        isEnabledRef.current = true;
        if (isUnlocked) dispatch(fetchPromotions(url, id));
      }
      if (!response?.data?.length && isUnlocked) {
        sessionStorage.setItem("isMembershipUnlocked", "false");
      }
      getMembershipDetails(
        response?.data?.[0]?.name,
        response?.data?.[0]?.description
      );
    }
  };

  useEffect(() => {
    enableSecretMemberDeal();
  }, [hotelData, dateRange, response]);

  if (!isEnabledRef?.current || isUnlocked) {
    return null;
  }

  return (
    <>
      <div
        className={
          isRatePlan ? "secretMemberDealReateplanBox" : "secretMemberDealBox"
        }
      >
        <div className="secretMemberDealHeading">
          <div className="secretMemberTitleBox">
            <h3>{membershipDetails?.name}</h3>
            <div className="secretMemberVerticalLine"></div>
            <p>{membershipDetails?.description}</p>
          </div>
        </div>
        <div className="secretMemberRateBox">
          <div className="secretMemberRateBox ">
            <h3 className={isUnlocked ? "" : "blurDiscountedPrice"}>
              {" "}
              {currency(hotelData?.currency)} {price}
            </h3>
            <span>per night</span>
          </div>
          <div className="secretMemberUnlock">
            <button
              type="button"
              onClick={() => setShowMembershipModal({ isOpen: true })}
            >
              <img src={unlockSVG} alt="unlock" />
              {isUnlocked ? "Unlocked" : "Unlock"}
            </button>
          </div>
        </div>
      </div>
      {showMembershipModal?.isOpen && (
        <MembershipDealsModal
          isOpen={showMembershipModal?.isOpen}
          onClose={() => setShowMembershipModal({ isOpen: false })}
          getSecretMemberDealUrl={getSecretMemberDealUrl}
          applyPromotion={applyPromotion}
        />
      )}
    </>
  );
};

export default SecretMemberDeal;
